<template>
  <div id="choosePurcharseGoods">
    <div class="invoicingHead">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="back" href="javascript:;">选择进货单</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>选择退货商品</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <div class="search-box">
        <div class="flex-between">
          <div class="flex-start">
            <div class="mr20">关联进货单号：{{ orderCode }}</div>
            <div>
              <span>出库仓库：{{ repositoryName }}</span>
              <!-- <el-select size="small" v-model="repositoryId" shopStore="入库仓库">
                            <el-option v-for="item in repositoryList" :key="item.repositoryId" :label="item.repositoryName" :value="item.repositoryId"></el-option>
                        </el-select> -->
            </div>
          </div>
          <div>
            <el-input
              size="small"
              placeholder="输入商品名称"
              v-model="synthesisSearch"
              style="width: 200px"
            ></el-input>
            <el-button size="small" @click="search" type="primary">搜索</el-button>
          </div>
        </div>
      </div>
      <div class="content">
        <table
          class="table"
          width="100%"
          style="table-layout: fixed"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.3)"
          element-loading-text="数据正在加载中"
          element-loading-spinner="el-icon-loading"
        >
          <tr class="th">
            <td>
              <span class="mr20">退货商品</span>
              <el-checkbox
                v-model="totalClick"
                @change="totalChecked"
                style="margin-right: 20px"
                >全选</el-checkbox
              >
              <el-button type="primary" plain size="mini" @click="back">取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="settleAccount"
                :disabled="disabled"
                >结算</el-button
              >
            </td>
            <td>退货单价</td>
            <td>实际数量</td>
          </tr>
          <tr
            class="td"
            v-for="(item, index) in singlePurchaseAllList"
            :key="index"
            style="border-bottom: 1px solid red"
          >
            <td style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
              <div class="flex-start">
                <div class="flex-start mr20">
                  <el-checkbox
                    v-model="item.click"
                    style="margin: 32px 10px 0 0"
                    @change="commidityClick(item, index)"
                  ></el-checkbox>
                  <img
                    v-if="item.goodsImage"
                    class="edit-item_img"
                    style="margin: 10px 0"
                    :src="item.goodsImage"
                    alt
                  />
                  <img
                    v-if="!item.goodsImage"
                    class="edit-item_img"
                    style="margin: 10px 0"
                    src="@/assets/icon/defaultPic.png"
                    alt
                  />
                </div>
                <div class="flex-column-start mt20">
                  <div>
                    {{ item.goodsName }}
                    {{ item.valueContent ? "(" + item.valueContent + ")" : "" }}
                  </div>
                  <div class="flex-start mt5">
                    <div v-if="item.isInfiniteStock == 0" class="mr10">
                      可用库存：{{ item.qrcTotalStockCount ? item.qrcTotalStockCount : 0
                      }}{{ item.goodsUnit }}
                    </div>
                    <div v-if="item.isInfiniteStock == 1" class="mr10">无限库存</div>
                    <div>
                      可退货数量：{{ item.inputNum - item.outputNum }}{{ item.goodsUnit }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <span class="center">￥ {{ item.takePrice.toFixed(2) }}</span>
            </td>
            <td>
              <div class="flex-end mr70">
                ￥ {{ (item.takePrice * item.goodsNum).toFixed(2) }}
              </div>
              <div class="flex-end mr40" v-if="item.inputNum - item.outputNum == 0">
                已全部退货
              </div>
              <div class="flex-end mr20" v-else>
                <el-input-number
                  v-model="item.goodsNum"
                  size="small"
                  @change="handleChange(item)"
                  :min="minNum"
                  :max="maxNum"
                  label="描述文字"
                ></el-input-number>
              </div>
            </td>
          </tr>
        </table>
        <div
          class="center"
          style="
            padding-top: 40px;
            box-sizing: border-box;
            font-size: 18px;
            font-weight: 500;
            color: #000;
          "
        >
          {{ chooseLength }}种 ，￥{{ totalMony.toFixed(2) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repositoryList, singlePurchaseAll } from "../api";
export default {
  data() {
    return {
      orderCode: "",
      orderId: "",
      synthesisSearch: "",
      repositoryId: "",
      repositoryList: [],
      totalClick: false,
      singlePurchaseAllList: [],
      list: [],
      lists: [],
      disabled: false,
      maxNum: 999999,
      loading: false,
      totalMony: 0,
      chooseLength: 0,
      status: "",
      minNum: 0,
      repositoryName: "",
    };
  },
  created() {
    this.orderCode = localStorage.getItem("orderCode");
    this.orderId = localStorage.getItem("orderId");
    this.getSinglePurchaseAll();
    // this.getRepositoryList()
    this.lists = JSON.parse(localStorage.getItem("singlePurchaseAllList") || "[]");
    this.lists.forEach((item) => {
      if (item.click == true) {
        this.totalMony += item.takePrice * item.goodsNum;
      }
    });
    var trueList = this.lists.filter((item) => {
      return item.click == true;
    });
    this.chooseLength = trueList.length;
  },
  updated() {
    if (this.lists.length !== 0) {
      this.$nextTick(() => {
        if (this.status == 1 && this.synthesisSearch) {
          this.singlePurchaseAllList = this.singlePurchaseAllList;
        } else {
          this.singlePurchaseAllList = this.lists;
        }
        var bool = this.lists.every((item) => {
          return item.click == true;
        });
        if (bool) {
          this.totalClick = bool;
        }
      });
    }
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 搜索
    search() {
      this.status = 1;
      this.getSinglePurchaseAll(this.synthesisSearch);
    },
    // 获取列表
    getSinglePurchaseAll(synthesisSearch) {
      this.loading = true;
      singlePurchaseAll({
        isManager: 1,
        pageNo: 1,
        row: 10,
        orderId: this.orderId,
        synthesisSearch: synthesisSearch,
      }).then((res) => {
        if (res.code == 1) {
          this.loading = false;
          this.singlePurchaseAllList = res.data.productJson;
          for (var i in this.singlePurchaseAllList) {
            this.singlePurchaseAllList[i].click = false;
          }
          this.singlePurchaseAllList.map((item) => {
            this.$set(item, "goodsNum", item.inputNum - item.outputNum);
          });
          this.singlePurchaseAllList.every((item) => {
            return (this.disabled = item.inputNum == 0 ? true : false);
          });
          this.repositoryName = res.data.repositoryName;
          sessionStorage.setItem("stockName", res.data.repositoryName);
          sessionStorage.setItem("stockId", res.data.repositoryId);
          sessionStorage.setItem("supplyName", res.data.supplierName);
          sessionStorage.setItem("supplyId", res.data.supplierId);
          // localStorage.setItem("singlePurchaseAllList", JSON.stringify(this.singlePurchaseAllList))
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 仓库
    // getRepositoryList() {
    //     repositoryList({
    //         isManager: 1,
    //         isNeedAll: 1,
    //         pageNo: 1,
    //         row: 999
    //         // shopStoreId: this.shopInformation.shopStoreId
    //     })
    //     .then(res => {
    //         if (res.code == 1) {
    //             this.repositoryList = res.data
    //         }
    //     })
    // },
    handleChange(item) {
      // 当库存为0时，可退货数为0    当可退货数大于库存时，可退货数为库存数量     当可退货数小于库存时，可退货数量为可退货数
      if (item.isInfiniteStock == 0) {
        if (item.qrcTotalStockCount < item.inputNum) {
          this.maxNum = item.qrcTotalStockCount;
        } else {
          this.maxNum = item.inputNum - item.outputNum;
        }
      } else if (item.isInfiniteStock == 1) {
        this.maxNum = item.inputNum - item.outputNum;
      }
      let reg = /^[1-9]\d*$/;
      if (item.unitType == 1) {
        this.minNum = 1;
        if (!reg.test(item.goodsNum)) {
          this.$message({
            message: "计数商品不能为小数或零",
            duration: 1000,
            type: "error",
          });
          return;
        }
      } else if (item.unitType == 2) {
        this.minNum = 0.01;
      }
      if (item.goodsNum == 0) {
        this.$message({
          message: "商品数量不能为零",
          duration: 1000,
          type: "error",
        });
        return;
      }
      this.totalMony = 0;
      this.singlePurchaseAllList.forEach((item) => {
        console.log(item.goodsNum, "item.goodsNum", item);
        if (item.click == true) {
          // if (item.goodsNum > item.inputNum - item.outputNum) {
          //     item.goodsNum = item.inputNum - item.outputNum
          // }
          this.totalMony += item.takePrice * item.goodsNum;
        }
      });
      localStorage.setItem(
        "singlePurchaseAllList",
        JSON.stringify(this.singlePurchaseAllList)
      );
    },
    // 商品是否选中
    commidityClick(item, index) {
      var arr = this.singlePurchaseAllList;
      if (item.inputNum - item.outputNum == 0) {
        this.$message.error("该商品已无可退数量");
        this.singlePurchaseAllList[index].click = false;
        return;
      } else if (item.qrcTotalStockCount == 0 && item.isInfiniteStock == 0) {
        this.singlePurchaseAllList[index].click = false;
        this.$message.error("可用库存为0");
        return;
      }
      console.log(item.click, "商品是否选中状态");
      if (item.click == false) {
        this.totalClick = false;
        for (let i in this.list) {
          if (this.list[i].productId == item.productId) {
            this.list.splice(i, 1);
          }
        }
        console.log(this.list, "false");
        this.totalMony = 0;
        this.singlePurchaseAllList.forEach((item) => {
          if (item.click == true) {
            this.totalMony += item.takePrice * item.goodsNum;
          }
        });
        this.chooseLength = this.list.length;
      } else {
        this.totalClick = arr.every((item1) => {
          return item1.click;
        });
        this.list.push(item);
        console.log(this.list, "true");
        this.chooseLength = this.list.length;
        this.totalMony = 0;
        this.singlePurchaseAllList.forEach((item) => {
          if (item.click == true) {
            this.totalMony += item.takePrice * item.goodsNum;
          }
        });
      }
      localStorage.setItem(
        "singlePurchaseAllList",
        JSON.stringify(this.singlePurchaseAllList)
      );
      //因为goodslist click值变化 界面checkbox状态不变
      this.singlePurchaseAllList = "";
      this.singlePurchaseAllList = arr;
      //
    },
    // 全选
    totalChecked() {
      var bool = this.singlePurchaseAllList.some((element) => {
        return (
          element.qrcTotalStockCount == 0 || element.inputNum - element.outputNum == 0
        );
      });
      console.log(bool);
      if (bool) {
        this.totalClick = false;
        this.$message.error("当前有无可退商品，不能全选哦~");
        return;
      }
      this.singlePurchaseAllList.forEach((element) => {
        element.click = this.totalClick;
      });
      if (this.totalClick) {
        this.singlePurchaseAllList.forEach((element) => {
          this.list.push(element);
          console.log(this.list, "全选");
        });
        this.chooseLength = this.singlePurchaseAllList.length;
        this.totalMony = 0;
        this.singlePurchaseAllList.forEach((item) => {
          if (item.click == true) {
            this.totalMony += item.takePrice * item.goodsNum;
          }
        });
      } else {
        this.list = [];
        this.totalMony = 0;
        this.chooseLength = 0;
      }
      localStorage.setItem(
        "singlePurchaseAllList",
        JSON.stringify(this.singlePurchaseAllList)
      );
    },
    // 结算
    settleAccount() {
      console.log(this.lists, this.singlePurchaseAllList);
      var bool = this.singlePurchaseAllList.some((item) => {
        return item.click == true;
      });
      if (bool == false) {
        this.$message.error("请选择商品");
        return;
      }
      this.$router.push("/invoicing/choosePurcharseReturn");
      localStorage.setItem("orderId", this.orderId);
    },
    back() {
      localStorage.removeItem("singlePurchaseAllList");
      this.$router.push("/invoicing/chooseGoodsPurchasePrice");
    },
  },
};
</script>

<style scoped>
/* .inputnumberbox{position: relative;padding: 0 35px;width: 105px;}
.addicon,.minus{
    width: 30px;
    height: 30px;
    display: inline-block;
    position: absolute;
    padding: 5px;
    background-color: #f0f0f0;
    font-size: 18px;
    color: #333;
}
.minus{left: 0;top: 0;}
.addicon{right: 0;top: 0;}
input{width: 35px;height: 30px;text-align: center}
.lightgray{color: #aaa} */
.searchGroup {
  position: absolute;
  top: 100px;
  padding: 25px;
  width: calc(100vw - 270px);
}
.search-box {
  width: 100%;
  height: 59px;
  line-height: 59px;
  background: rgba(248, 248, 249, 1);
  padding: 0 20px;
  box-sizing: border-box;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
}
.center {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.flex-end {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.flex-column-start {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
}
.flex-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
}
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
}
.mr20 {
  margin-right: 20px;
}
.mr40 {
  margin-right: 40px;
}
.mr70 {
  margin-right: 70px;
  margin-bottom: 5px;
}
.mt20 {
  margin-top: 20px;
}
.mt5 {
  margin-top: 5px;
}
.mr10 {
  margin-right: 10px;
}
.content {
  /* box-sizing: border-box; */
  width: 100%;
  /* height: 650px; */
  /* overflow-y: scroll; */
  height: auto;
  /* padding: 25px 0 25px 0; */
  color: #606266;
  font-size: 14px;
  margin-top: 20px;
}
table {
  border: 0;
  border-collapse: 0;
  border-spacing: 0;
  font-size: 14px;
}
.table {
  width: 100%;
  font-size: 12px;
}
.th {
  background: #f8f8f8;
  padding: 15px;
  height: 40px;
  font-size: 14px;
  color: #909399;
  font-weight: 600;
}
.td td {
  height: 55px;
  border-bottom: 1px solid #ebeef5;
  /* text-align: center;     */
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}
.th td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  text-align: center;
}
.th td:first-child {
  text-align: left;
  padding-left: 17px;
}
.th td:last-child {
  text-align: right;
  padding-right: 28px;
}
td {
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.edit-item_img {
  height: 65px;
  width: 65px;
  margin-right: 20px;
}
</style>
